import AdminContainer from './admin'

export default AdminContainer